import { ActionTree, MutationTree } from 'vuex'
import { IRootState } from '@/store'
import { IBrandsState } from '@/store/modules/brands/interfaces/IBrandsState'
import { BrandsMutationType } from '@/store/modules/brands/interfaces/mutation-type'
import { IBrandsMutation } from '@/store/modules/brands/interfaces/IBrandsMutation'
import { IBrandsActions } from '@/store/modules/brands/interfaces/IBrandsAction'
import { BrandsActionType } from '@/store/modules/brands/interfaces/action-type'
import {
  IFetchBrandsRequest
} from '@/store/modules/brands/interfaces/brands/api/fetchBrands/IFetchBrandsRequest'
import { brandsAPI } from '@/store/modules/brands/api/getBrands'
import {
  IFetchBrandsResponse
} from '@/store/modules/brands/interfaces/brands/api/fetchBrands/IFetchBrandsResponse'
import {
  IFetchSelectedBrandsRequest
} from '@/store/modules/brands/interfaces/selectedBrands/api/fetchSelectedBrands/IFetchSelectedBrandsRequest'
import { IBrands } from '@/store/modules/brands/interfaces/IBrands'

const state = (): IBrandsState => ({
  brands: {
    total: 0,
    offset: 0,
    limit: 0,
    results: []
  },
  selectedBrands: null,
  search: '',
  loading: false
})

const mutations: MutationTree<IBrandsState> & IBrandsMutation = {
  [BrandsMutationType.SET_LOADING] (state: IBrandsState, payload: boolean) {
    state.loading = payload
  },
  async [BrandsMutationType.SET_BRANDS] (state: IBrandsState, payload: IFetchBrandsResponse) {
    state.brands = payload
  },
  async [BrandsMutationType.SET_SELECTED_BRANDS] (state: IBrandsState, payload: any) {
    state.selectedBrands = payload
  },
  async [BrandsMutationType.SET_SEARCH] (state: IBrandsState, payload: string) {
    state.search = payload
  }
}

const actions: ActionTree<IBrandsState, IRootState> & IBrandsActions = {
  async [BrandsActionType.FETCH_BRANDS] ({ commit }, dto: IFetchBrandsRequest) {
    commit(BrandsMutationType.SET_LOADING, true)
    const data = await brandsAPI.fetchOurBrands(dto)
    commit(BrandsMutationType.SET_BRANDS, data)
    commit(BrandsMutationType.SET_LOADING, false)
  },
  async [BrandsActionType.FETCH_BRANDS_AFTER_LOGIN] ({ commit }, payload) {
    commit(BrandsMutationType.SET_LOADING, true)
    const data = await brandsAPI.fetchOurBrandsAfterLogin(payload.CustomerType)
    commit(BrandsMutationType.SET_BRANDS, data)
    commit(BrandsMutationType.SET_LOADING, false)
  },
  async [BrandsActionType.FETCH_SELECTED_BRANDS] ({ commit }, dto: IFetchSelectedBrandsRequest) {
    commit(BrandsMutationType.SET_LOADING, true)
    const data = await brandsAPI.fetchAllOurBrands(dto)
    commit(BrandsMutationType.SET_SELECTED_BRANDS, data)
    commit(BrandsMutationType.SET_LOADING, false)
  }
}

const BrandsModule = {
  state,
  mutations,
  actions
}

export default BrandsModule
